import { GET_VIDEO_CONTENT } from '../constants/card';

export const getVideoContent = param => ({
  type: GET_VIDEO_CONTENT,
  payload: param,
});
